<template>
  <el-dialog
    :title="formData && formData.index !== undefined ? '编辑白名单用户' : '新增白名单用户'"
    :visible="visible"
    @close="$emit('close')"
    width="30%">
    <el-form>
      <el-form-item label="用户ID">
        <el-input v-model="formData.value"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="$emit('close')">取消</el-button> <!-- 修改：直接使用路由跳转关闭对话框 -->
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'WhitelistEditDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentType: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      default: null
    },
    whitelist: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      formData: {
        value: '',
        index: undefined
      }
    };
  },
  watch: {
    // 新增对visible的监听，在对话框打开时重置表单
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.formData = this.item 
            ? { ...this.item } 
            : { value: '', index: undefined };
        }
      }
    },
    // 修改原有item监听器，保持数据同步
    item: {
      immediate: true,
      handler(newVal) {
        this.formData = newVal 
          ? { ...newVal } 
          : { value: '', index: undefined };
      }
    }
  },
  methods: {
    ...mapActions('tradeWhitelist', ['updateList']),

    // 新增模块状态验证
    validateStoreState() {
      if (!this.$store.state.tradeWhitelist) {
        console.error('[Vuex] 模块状态未找到:', this.$store.state);
        this.$message.error('模块状态异常，请检查配置');
        return false;
      }
      return true;
    },

    handleSubmit() {
      if (!this.validateStoreState()) return;

      const newValue = this.formData.value.trim();
      // 修复：使用props传递的whitelist
      if (this.formData.index !== undefined) {
        const oldValue = this.whitelist[this.formData.index];
        if (newValue === oldValue) {
          // 值未修改时直接提交
          this.$emit('submit', this.whitelist); // 新增：未修改时直接触发提交
          return; // 新增返回避免继续执行
        } else if (this.whitelist.includes(newValue)) {
          this.$message.error('用户ID已存在');
          return;
        }
      } else {
        if (this.whitelist.includes(newValue)) {
          this.$message.error('用户ID已存在');
          return;
        }
      }

      // 创建新数组避免直接修改 state
      const newList = [...this.whitelist];

      if (this.formData.index !== undefined) {
        // 编辑模式：替换原有条目（修改为存储纯字符串）
        newList[this.formData.index] = this.formData.value;
      } else {
        // 新增模式：追加新条目（修改为存储纯字符串）
        newList.push(this.formData.value);
      }

      this.updateList({
        type: this.currentType,
        newList: newList,
        pair: this.$store.state.tradeWhitelist.currentPair // 传递当前pair
      }).then(() => {
        this.$emit('submit', newList);
      });
    }
  }
};
</script>
